'use strict';

export default class Notes {
    userId;
    content; 

    constructor(userId, content = {}) {
        this.userId = userId;
        this.content = content;
    }

    update(presentationId, slideId, note) {
      if (presentationId === undefined || slideId === undefined) {
        return false;
      }

      if (!this.content[presentationId]) {
        this.content[presentationId] = {};
      }

      if (note === undefined) {
        delete this.content[presentationId][slideId];

        if (Object.keys(this.content[presentationId]).length === 0) {
          delete this.content[presentationId];
        }
      } else {
        this.content[presentationId][slideId] = note;
      }

      return true;
    }

    get(presentationId, slideId, defaultValue) {
      if (presentationId === undefined || slideId === undefined) {
        return defaultValue;
      }

      if (!this.content[presentationId]) {
        return defaultValue;
      }

      if (this.content[presentationId][slideId] !== undefined) {
        return this.content[presentationId][slideId];
      }

      return defaultValue;
    }

    list(presentationId) {
      if (presentationId === undefined || !this.content[presentationId]) {
        return [];
      }

      let slideIds = Object.keys(this.content[presentationId]);
      let notes = [];

      for(let slideId of slideIds) {
        notes.push({
          slideId: slideId,
          text: this.content[presentationId][slideId]
        });
      }

      return notes;
    }
}



// WEBPACK FOOTER //
// ./src/javascript-classes/Notes.js